// Added by Jake O to support Rx launch (2026-09-01)
document.addEventListener('LensAdvizor:postAddToCart', async () => {
	if (!window.FoxThemeEvents) return

	const cart = await fetch('/cart.js', {
		credentials: 'same-origin',
		headers: { 'X-Requested-With': 'XMLHttpRequest' }
	}).then((response) => response.json())

	window.FoxThemeEvents.emit('ON_ITEM_ADDED', cart)
})